export function scrollTop() {   
    
    const headerHeight  = $(".header").innerHeight();
    const anchoredBlock = $('main');
    const _scroll       = $('#scroll-top');
    var lastScrollTop   = 0;

    window.onscroll = function(e) {
        var top         = Math.max(document.body.scrollTop,document.documentElement.scrollTop);
        var st          = top || document.documentElement.scrollTop;
        var _heightPage = $(window).height();
        if ( top > _heightPage/2 ) {         
            // upscroll code     
            _scroll.addClass('up');
            _scroll.css('bottom','80px');
        } else {          
            _scroll.removeClass('up');
            setTimeout(function(){
                $('#scroll-top').css('bottom','0');
            }, 350);
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }

    _scroll.on('click', function (e) {
        $("html, body").animate({scrollTop: anchoredBlock.offset().top - headerHeight }, 500);
    });
    
}


// WEBPACK FOOTER //
// ./assets/js/modules/scrollTop.js